export default "__VITE_ASSET__TH8w$yg4__"